<section class="content-header">

    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">State Wise - Testings</h1>
            </div>

        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</section>
<section class="content">
    <!-- Default box -->
    <div class="container-fluid">

        <div class="card">

            <div class="card-body">
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <td style="font-weight:bold">Sr No</td>
                            <td style="font-weight:bold">State Name</td>
                            <td style="font-weight:bold">Samples Tested</td>
                            
                        </tr>
                        <tr>
                            <td style="font-weight:bold" colspan="2">Total Testings Conducted</td>
                            <td style="font-weight:bold">{{totalTesting}}</td>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            *ngFor="let testing of testingsData | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                            <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                            <td>{{ testing.stateName }}</td>
                            <!-- <td><a href="./list-testing/{{testing.stateCode}}">{{ testing.total }}</a></td></tr> -->
                            <td><a [routerLink]="['/list-testing/',testing.stateCode]">{{ testing.total }}</a></td></tr>
                    </tbody>
                </table>
                <pagination-controls (pageChange)="p = $event" class="float-right"></pagination-controls>
            </div>
        </div>
    </div>
</section>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>